<template>
  <div class="container">
    <mt-header fixed title="合同修正" class="head">
      <router-link to="/contract" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
      <mt-button slot="right" @click="commit">提交</mt-button>
    </mt-header>
    <form>
      <div class="form">
        <div class="item-group c_m_b_10 bg_white">
          <div class="item-title c_nowrap">
            委托方
          </div>
          <div class="item-content">
                  <span class="item-value ">
                      <input type="text" placeholder="请填写委托方" v-model="name">
                  </span>
          </div>
        </div>
        <div class="item-group c_m_b_10 bg_white">
          <div class="item-title c_nowrap">
            身份证号
          </div>
          <div class="item-content">
                  <span class="item-value ">
                      <input type="text" placeholder="请填写身份证号" v-model="idnumber">
                  </span>
          </div>
        </div>
        <div class="item-group c_m_b_10 bg_white">
          <div class="item-title c_nowrap">
            通讯地址
          </div>
          <div class="item-content">
                  <span class="item-value ">
                      <input type="text" placeholder="请填写通讯地址" v-model="address">
                  </span>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import axios from 'axios'
  import {Indicator, MessageBox} from 'mint-ui';
  export default {
    data(){
      return{
        contractid:"",
        name:"",
        address:"",
        idnumber:""
      }
    },
    mounted(){
      let id = this.$route.params.id;
      if(id){
        this.contractid = id;
      }else{
        this.$router.push('/contract');
      }
      this.load();
    },
    methods:{
      // 获取工序详情
      load:function(){
        var $that = this;
        this.$ajax.get(this.$$api.mobile.getContractDetail,{
            'contractid':$that.contractid,
          },response=>{
            if (response.status >= 200 && response.status < 300) {
              if(response.data.success=='success'){
                var res=response.data.detailMsg.data;
                console.log(res)
                $that.name=res.name;
                $that.address=res.address;
              }
            } else {
              console.log(response,0);
            }
        });
      },
      //提交
      commit(){
        var $that = this;
        if($that.name){
          this.$ajax.post(this.$$api.mobile.updateContract,{
            'contractid':$that.contractid,
            'clientname':$that.name,
            'postaladdress':$that.address,
            'idnumber':$that.idnumber
          },response=>{
            if (response.status >= 200 && response.status < 300) {
              if(response.data.success=='success'){
                let id=$that.contractid;
                $that.$router.push({name: "contractDetail", params: {'id': id}});
              }
            } else {
              console.log(response,0);
            }
          });
        }
      }
    }
  }
</script>
<style scoped>
  .container{
    font-size:4vw;
  }
  ::-webkit-input-placeholder {
    font-size: 3vw;
    color: rgb(184,195,206);
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .item-group {
    width: 100%;
    box-sizing: border-box;
    word-wrap: break-word;
    padding: 3.226vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .item-title {
    width: 50%;
    text-align: left;
    height: 100%;

  }

  .item-content {
    width: 50%;
    text-align: right;
    font-size: 4vw;
    /*background: blue;*/
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .item-content input {
    font-size: 4vw;
  }

  .item-value {
    width: 90%;
    display: inline-block;
    height: 100%;
    padding: 0;
    margin: 0;
    color:#000;
  }

  .item-value input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    text-align: right;
    padding: 0;
    margin: 0;
    display: flex;
    align-content: center;
  }
  >>> .mint-switch{
    justify-content: flex-end;
  }



  /*table*/
  .table .table-header{
    width: 100%;
    box-sizing: border-box;
    padding: 3.226vw;
    background: rgb(184,195,206);
    color: #fff;
    font-size: 4vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .table-title{
    /*width: 10%;*/
  }
  .table-body{
    padding: 3.226vw;
    background: #fff;
  }
  .table-body .item-value{
    width: 100%;
  }
  /*.table-body input{*/
  /*background: transparent;*/
  /*}*/
  .table-group{
    margin-bottom: 3vw;
  }
  .table-content{
    flex-wrap: wrap;
    display: flex;
  }
  .table-content label{
    margin-left: 3vw;
    margin-top: 3vw;
    display: flex;
    align-items: center;
  }
  .table-content input[type='text']{
    width: 100%;
    background: transparent;
    border: 0;
    outline: none;
    border-bottom: 1px solid #ccc;
  }

</style>



// WEBPACK FOOTER //
// src/components/contractModify.vue